var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtintor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34936 38.5L26 0.999999L47.6506 38.5H4.34936Z",
    fill: "#FF0000",
    stroke: "#0008"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2314_6078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 16,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2314_6078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 32.5C23.3375 32.5 22.9844 32.3531 22.6906 32.0594C22.3969 31.7656 22.25 31.4125 22.25 31V30.25H29.75V31C29.75 31.4125 29.6031 31.7656 29.3094 32.0594C29.0156 32.3531 28.6625 32.5 28.25 32.5H23.75ZM22.25 29.5V25.75H29.75V29.5H22.25ZM22.325 25C22.45 24.425 22.7125 23.8844 23.1125 23.3781C23.5125 22.8719 24.0188 22.5 24.6313 22.2625C24.5063 22.1625 24.3937 22.0531 24.2937 21.9344C24.1937 21.8156 24.1063 21.6875 24.0312 21.55L20.75 20.875V20.125L24.0312 19.45C24.2188 19.0875 24.4844 18.7969 24.8281 18.5781C25.1719 18.3594 25.5625 18.25 26 18.25C26.2625 18.25 26.5125 18.2937 26.75 18.3812C26.9875 18.4688 27.2 18.5875 27.3875 18.7375L29.75 18.25V22.75L27.3687 22.2625C27.9562 22.5 28.4531 22.8594 28.8594 23.3406C29.2656 23.8219 29.5375 24.375 29.675 25H22.325ZM26 21.25C26.2125 21.25 26.3906 21.1781 26.5344 21.0344C26.6781 20.8906 26.75 20.7125 26.75 20.5C26.7375 20.275 26.6625 20.0938 26.525 19.9563C26.3875 19.8188 26.2125 19.75 26 19.75C25.7875 19.75 25.6094 19.8219 25.4656 19.9656C25.3219 20.1094 25.25 20.2875 25.25 20.5C25.25 20.7125 25.3219 20.8906 25.4656 21.0344C25.6094 21.1781 25.7875 21.25 26 21.25Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtintor);
export default __webpack_public_path__ + "static/media/extintor.4e0f5eea3a1ad68a1e6599a590b35388.svg";
export { ForwardRef as ReactComponent };